import { EmptyState } from '@/components/shared/empty-state';
import loadIntlMessages from '@/logic/helpers/loadIntlMessages';
import { pxToRem } from '@/theme/typography';
import { useTheme } from '@mui/material';
import { GetServerSideProps, GetServerSidePropsContext, NextPage } from 'next';

const UnAvailable: NextPage = () => {
  const theme = useTheme();

  return (
    <EmptyState
      title='global.un_published.item'
      headTitle='global.un_published.item'
      img='/icons/booking/empty-session-image.svg'
      imgWidth={{
        mobile: '171px',
        tablet: pxToRem(456.24),
      }}
      imgHeight={{
        mobile: '149.32px',
        tablet: pxToRem(398.19),
      }}
      sx={{
        paddingX: {
          mobile: '16px',
          tablet: '0px',
        },
        height: {
          mobile: 'calc(100vh - 56px)',
          mediumDesktop: 'calc(100vh - 100px)',
        },
      }}
      titleSx={{
        marginTop: {
          mobile: '16.68px',
          tablet: pxToRem(44.5),
        },
        fontSize: {
          mobile: '16px',
          tablet: pxToRem(20),
        },
        letterSpacing: {
          tablet: pxToRem(0.1),
        },
        color: theme.palette.grey[50],
      }}
    />
  );
};

export const getServerSideProps: GetServerSideProps = async (
  context: GetServerSidePropsContext
) => {
  const { locale, defaultLocale } = context;

  return {
    props: {
      intlMessages: await loadIntlMessages(locale as string, defaultLocale),
    },
  };
};

export default UnAvailable;
